import React from 'react'

const Manual_tipo_de_orden_cloudbeds = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     Cloudbeds - Tipo de Orden
     </h2>
     <p className="text-lg text-gray-700 mb-6">
            Esta guía proporciona un proceso sencillo para integrar Cloudbeds mediante la
            creación de un tipo de pedido personalizado, lo que garantiza que su empresa
            pueda gestionar y generar informes de pedidos eficazmente. Simplifica los pasos
            de integración y mejora la eficiencia operativa. Siguiendo estas instrucciones, los
            usuarios pueden garantizar un seguimiento preciso de los pedidos específicos de
            su interfaz de Cloudbeds, lo que mejora la capacidad general de generación de
            informes y gestión.
     </p>
     <iframe
          src="https://scribehow.com/embed/Cloudbeds__Tipo_de_Orden__G_epbJSeQq2I20LMbsbYjQ?as=scrollable"
          className="scribe-iframe-cloudbeds-2"
          width="100%"
          height="3500"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_tipo_de_orden_cloudbeds